import type { HydratedConnectorDragonTile } from "@/api/connectors/index";
import type { ConnectorTile, InstalledConnector } from "@/types/connectors";
import type { DragonTile } from "@/types/dragon-tiles";

import { BYOC_PARENT_TILE_ID } from "@/features/Connectors/byocConstants";

function mergeByocTileData(
  installed: InstalledConnector,
  dragonTile: DragonTile,
): ConnectorTile {
  return {
    ...dragonTile,
    name: installed.name || dragonTile.name,
    type: "byoc",
    logoUrl: installed.logoUrl,
    events: installed.events,
  };
}

/**
 * Hydrate BYOC from the real `type=byoc` dragon tile. Events come from the
 * BYOC events endpoint (see `@/api/connectors/byocEvents`); callers that only
 * need the tile (route loaders) can omit them.
 */
export function buildByocHydratedConnector({
  siteName = "",
  byocDragonTiles,
  events,
}: {
  siteName?: string;
  byocDragonTiles: DragonTile[];
  events?: InstalledConnector["events"];
}): HydratedConnectorDragonTile {
  const dragonTile = byocDragonTiles[0];

  if (!dragonTile) {
    throw new Error("No BYOC dragon tile available from type=byoc.");
  }

  const installed: InstalledConnector = {
    id: BYOC_PARENT_TILE_ID,
    name: siteName || dragonTile.name,
    logoUrl: "",
    type: "byoc",
    description: "Bring your own connector events and sequences.",
    events,
  };

  return {
    connectorId: BYOC_PARENT_TILE_ID,
    installed,
    dragonTile,
    tile: mergeByocTileData(installed, dragonTile),
  };
}
